import { navigate } from 'gatsby-link';
import Actions from '../../actions/ActionWrapper';
import { IError } from '../../models/StateModels';
import { EventContainer } from '../../redux/EventContainer';
import { Store } from '../../redux/StoreContainer';
import { CustomCookieManager } from './CustomCookieManager';

const defaultLoginNeeededAction = () => {
  if (typeof window !== 'undefined') navigate('/login');
};

class _LoginManager {
  private _events: {
    listener: string;
    uID: string;
    callback: () => void;
  }[] = [];

  private _HasLogedIn: boolean = false;
  private _PasswordChangeNeeded: boolean = false;
  private _IsExpired: boolean = false;
  private static _instance: _LoginManager;

  public LoggedIn = (input: { detail: { type: string; subtype: string } }): void => {
    this._HasLogedIn = true;
    this._IsExpired = false;
    const evt = EventContainer.CreateCustomEvent('success', input);

    EventContainer.DispatchEvent(evt, 'auth');
  };

  public PasswordChangeNeeded = () => (this._PasswordChangeNeeded = true);
  public PasswordChangeNotNeeded = () => (this._PasswordChangeNeeded = false);
  public PasswordChanged = () => this.PasswordChangeNotNeeded();

  public LoginFailed = (input: {
    detail: { type: string; subtype: string; error: IError };
  }): void => {
    this._HasLogedIn = false;
    const evt = EventContainer.CreateCustomEvent('failed', input);
    EventContainer.DispatchEvent(evt, 'auth');
  };

  public Expired = (input: { detail: { type: string; subtype: string; error: IError } }): void => {
    this._IsExpired = true;
    const evt = EventContainer.CreateCustomEvent('expired', input);
    EventContainer.DispatchEvent(evt, 'auth');
  };

  public IsLoginNeeded = (): boolean => !this._HasLogedIn || this._IsExpired;

  public IsPasswordChangeNeeded = (): boolean => this._PasswordChangeNeeded;

  public LogOut = (): void => {
    this._HasLogedIn = false;
    this._IsExpired = false;
    CustomCookieManager.ClearCookies();
    Store.dispatch(Actions.Api.User.Login.resetStore());
  };

  public OnLogin = (uID: string, callback: () => void): void => {
    this._events.push({
      listener: 'success',
      uID: uID,
      callback: callback,
    });
    EventContainer.getEventTarget('auth').addEventListener('success', callback);
  };

  public OnLoginFailed = (uID: string, callback: () => void): void => {
    this._events.push({
      listener: 'failed',
      uID: uID,
      callback: callback,
    });
    EventContainer.getEventTarget('auth').addEventListener('failed', callback);
  };

  public OnExpired = (uID: string, callback?: () => void | undefined): void => {
    const _callback = callback || defaultLoginNeeededAction;
    this._events.push({
      listener: 'expired',
      uID: uID,
      callback: _callback,
    });
    EventContainer.getEventTarget('auth').addEventListener('failed', _callback);
  };

  public RemoveListeners = (uID: string): void => {
    const list = this._events.filter((i) => i.uID === uID);
    list.forEach((l) => {
      EventContainer.getEventTarget('auth').removeEventListener(l.listener, l.callback);
    });
    this._events = this._events.filter((i) => i.uID !== uID);
  };

  public static Instance() {
    return this._instance || (this._instance = new this());
  }
}

export const LoginManager = _LoginManager.Instance();
